import SnackbarMessage from "@/components/SnackbarMessage/SnackbarMessage.vue";
import auth_methods from "./one_time_pin_auth_methods";
import feedback_methods from "./one_time_pin_feedback_methods";
import input_methods from "./one_time_pin_input_methods";

const login_url = process.env.VUE_APP_LOGIN_URL;
const otp_verify_url = process.env.VUE_APP_OTP_VERIFY_URL;
const client_app = process.env.VUE_APP_CLIENT_APP || "property_aggregation";

export default {
  name: 'OneTimePin',
  components: {
    SnackbarMessage
  },

  data() {
    return ({
      otp: ['', '', '', '', '', ''],
      timer: 300,
      email: sessionStorage.getItem('pending_username') || '',
      timer_interval: null,
      error_message: '',
      success_message: 'Verification code has been sent to your email.',
      snackbar_timeout_id: null,
      is_loading: false,
      otp_verify_url: otp_verify_url,
      login_url: login_url
    });
  },

  computed: {
    formatted_timer() {
      const minutes = Math.floor(this.timer / 60);
      const seconds = this.timer % 60;
      return `${minutes}:${seconds.toString().padStart(2, '0')}`;
    }
  },

  mounted() {
    const pending_username = sessionStorage.getItem('pending_username');

    if (!pending_username) {
      this.$router.push('/login');
      return;
    }

    this.email = pending_username;
    this.start_timer();
    this.start_snackbar_timer();
  },

  beforeUnmount() {
    this.clear_timer();
    this.clear_snackbar_timer();
  },

  methods: {
    ...feedback_methods,
    ...input_methods,
    ...auth_methods(client_app),

    start_timer() {
      this.clear_timer();
      this.timer = 300;

      this.timer_interval = setInterval(() => {
        if (this.timer > 0) {
          this.timer -= 1;
        } else {
          this.clear_timer();
        }
      }, 1000);
    },

    clear_timer() {
      if (this.timer_interval) {
        clearInterval(this.timer_interval);
        this.timer_interval = null;
      }
    }
  }
};
